// extracted by mini-css-extract-plugin
module.exports = {"footer":"AddModal_footer__-N_zw"};